import React from "react";
import { Container } from "@mui/material";
import Navbar, { NAVBAR_SPACE } from "../Navbar/Navbar";
import { navbarBlue } from "../../Classes/theme";
import Ratings from "../Ratings/Ratings";
import PartnersLine from "../PartnersLine/PartnersLine";

export default function Cookies() {
  return (
    <>
      <Navbar logoWhite defaultColor={navbarBlue} />
      <div style={{ width: "100%", height: "120px" }} />
      <Container
        sx={{ color: "black", textAlign: "left", pb: "80px", px: NAVBAR_SPACE }}
        maxWidth="lg"
      >
        <div>
          <h1
            style={{
              textAlign: "left",
              fontSize: 28,
              fontWeight: "bold",
              color: "rgb(0, 0, 0)"
            }}
          >
            Zásady používání souborů cookie (Cookies policy)
          </h1>

          <br />
          Děkujeme, že jste navštívili naše webové stránky. Tato politika
          používání souborů cookie (dále jen „Cookies policy“) vysvětluje, jak
          používáme soubory cookie a podobné technologie na našich webových
          stránkách (dále jen „služby“). Tato Cookies policy je součástí našich
          Obecných podmínek použití a platí pro všechny návštěvníky našich
          našich webových stránek https://appliner.cz.
          <br />
          <br />
          <b>1. Co jsou soubory cookie?</b>
          <br />
          <br />
          Soubory cookie jsou malé textové soubory, které jsou ukládány do
          vašeho zařízení (například počítače, mobilního telefonu nebo tabletu),
          když navštívíte určité webové stránky. Soubory cookie nám umožňují
          rozpoznat váš prohlížeč nebo zařízení a zapamatovat si určité
          informace o vašich preferencích nebo akcích.
          <br />
          <br />
          <b>2. Jaké soubory cookie používáme a proč?</b>
          <br />
          <br />
          <b>• Nezbytně nutné soubory cookie:</b> Tyto soubory cookie jsou
          nezbytné pro fungování našich služeb a umožňují vám používat základní
          funkce, jako je navigace po stránkách a přístup k zabezpečeným
          oblastem.
          <br /> <br />
          <b>• Analytické soubory cookie:</b> Tyto soubory cookie nám pomáhají
          porozumět, jak návštěvníci používají naše služby, sbírají anonymní
          informace o tom, jak se pohybujete na našich stránkách a které stránky
          navštěvujete nejčastěji. Tyto informace nám pomáhají vylepšovat naše
          služby a zajistit, že naše stránky jsou pro vás co nejrelevantnější.
          Námi využívanou analytickou službou je Google Analytics (více zde:
          https://policies.google.com/technologies/partner-sites?hl=en).
          <br />
          <br />
          <b>• Reklamní soubory cookie:</b> Tyto soubory cookie se používají k
          zobrazování reklamních obsahů, které jsou relevantní pro vás a vaše
          zájmy. Také nám pomáhají sledovat účinnost našich reklamních kampaní.
          V této souvislosti mohou být na naše webové stránky navázány cookies
          společností Seznam, Facebook, Twitter a Google.
          <br />
          <br />
          <b>3. Jak mohu spravovat soubory cookie?</b>
          <br />
          <br />
          Většina webových prohlížečů vám umožňuje odmítnout přijímání souborů
          cookie a můžete je také smazat z vašeho zařízení pomocí nastavení
          prohlížeče. Pokud však odmítnete nebo smažete naše soubory cookie,
          některé funkce našich služeb mohou být omezeny.
          <br />
          <br />
          <b>4. Další informace</b>
          <br />
          <br />
          Pokud máte jakékoli otázky ohledně našich zásad používání souborů
          cookie, kontaktujte nás prostřednictvím info@metastream.cz.
          <br />
          <br />
          <b>5. Změny této Cookies policy</b>
          <br />
          <br />
          Tato Cookies policy může být občas aktualizována. Jakékoli změny budou
          zveřejněny na této stránce a vstoupí v platnost okamžikem zveřejnění
          aktualizované verze. Doporučujeme vám pravidelně kontrolovat tuto
          stránku pro nejnovější informace o našich zásadách používání souborů
          cookie.
        </div>
      </Container>
      <Ratings />
      <PartnersLine bgcolor="transparent" />
    </>
  );
}
